import NameRow from './NameRow'
import CashRow from './CashRow'
import ShiftDetailTotalExpense from './ShiftDetailTotalExpense'
import ShiftDetailTotalIncome from './ShiftDetailTotalIncome'
import ShiftDetailCard from './ShiftDetailCard'
import ShiftDetailOther from './ShiftDetailOther'
import ShiftDetailTotal from './ShiftDetailTotal'
import { currencyFormatter } from 'utils/formatter'
import { Modal, Button } from 'react-bootstrap'
import moment from 'moment'
import styles from './ShiftDetailModal.css'

class ShiftDetailModal extends React.Component {
  render () {
    let {shift, shiftDetails} = this.props
    return (
      <Modal backdrop='true' show={this.props.show} bsClass={`${styles.modal} shift-modal modal`} dialogClassName={`${styles.dialog} modal-dialog`}>
        <Modal.Body bsClass={`modal-body ${styles['modal-body']}`}>
          <div className='col-right-inner'>
            <div className='col-sm-12'>
              <div className='label-section'>
                SHIFT DETAILS
              </div>
              <div className='col-sm-12'>
                <div className='row list-detail'>
                  <NameRow label='Name' value={shift.employee_name} />
                  <NameRow label='Access' value={shift.outlet_name} />
                  <NameRow label='Starting Shift' value={moment.parseZone(shift.created_at).format('DD MMM YYYY HH:mm')} />
                  <NameRow label='Ending Shift' value={shift.ended_at ? moment.parseZone(shift.ended_at).format('DD MMM YYYY HH:mm') : '-'} />
                  <div className='row'>
                    <div className='col-sm-12'>
                      <div />
                    </div>
                  </div>
                  <div>
                    <div className='col-sm-12 shift-content'>
                      <div className='row'>
                        <div className='col-sm-12'>
                          <div className='form-group col-sm-12 label-section'>
                            <label>Cash</label>
                          </div>
                          <div className='col-sm-12 cash_detail no-padding-right'>
                            <CashRow label='Starting Cash' value={currencyFormatter(shift.starting_cash)} />
                            <CashRow label='Cash Sales' value={currencyFormatter(shift.cash_sales)} />
                            <CashRow label='Cash from Invoice' value={currencyFormatter(shift.cash_invoice)} />
                            <CashRow label='Cash Refunds' value={this._printCashRefund(shift)} />
                            <ShiftDetailTotalExpense shift={shift} shiftDetails={shiftDetails} />
                            <ShiftDetailTotalIncome shift={shift} shiftDetails={shiftDetails} />
                            <CashRow label='Expected Ending Cash' value={currencyFormatter(shift.expected_ending_cash)} />
                            <CashRow label='Actual Ending Cash' value={shift.ended_at ? currencyFormatter(shift.actual_ending_cash) : '-'} />
                          </div>
                        </div>
                      </div>
                      <ShiftDetailCard shift={shift} />
                      <ShiftDetailOther shift={shift} />
                      <ShiftDetailTotal shift={shift} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button onClick={this.props.onHide}>Close</Button>
        </Modal.Footer>
      </Modal>
    )
  }
  _printCashRefund = (shift) => {
    if (shift.cash_refund > 0) {
      return (`(${currencyFormatter(shift.cash_refund)})`)
    } else {
      return currencyFormatter(shift.cash_refund)
    }
  }

  _formatValueShift = (shift, value) => {
    return this._checkEndDate(shift) ? value : '-'
  }

  _checkEndDate = (shift) => {
    return (shift.ended_at !== null)
  }
}

ShiftDetailModal.propTypes = {
  shift: React.PropTypes.object,
  onHide: React.PropTypes.func,
  shiftDetails: React.PropTypes.array,
  onClickDoneButton: React.PropTypes.func
}

export default (ShiftDetailModal)



// WEBPACK FOOTER //
// ./app/pages/Reports/Shift/ShiftDetail/ShiftDetailModal/ShiftDetailModal.js